import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const HeroUpdated = ({
    backgroundImageOrVideo="backgroundImage",
    heading=null,
    content=null,
    calloutImages=null,
    button=null,
    backgroundImage=null
}) => {

    const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

    return (
      <div id="updated-banner" className="updated-banner ">
        <div className="updated-banner-bg-image container-fluid ph0">
          <div className="banner-inside row">
            <div className="col-12 col-md-6 col-lg-5 offset-lg-1 banner-text d-flex">
              <div>
                {heading &&
                <h1>{ htmlDecode(heading) }</h1>
                }
                <span className="orange-line-after" />
                {content &&
                <h2 dangerouslySetInnerHTML={{ __html: content }} />
                }
                {button &&
                <div className="cta-buttons">
                  <Link href={ button.link } className="button">{ button.text }</Link>
                </div>
                }
              </div>
            </div>
            {backgroundImageOrVideo == 'backgroundImage' &&
            <div className="col-12 col-md-6 banner-callout-imgs d-flex pr3 position-relative">
                <div className="banner-callout-imgs-inner">
                    {calloutImages && calloutImages.map((calloutImage) => (
                        <Link href={ calloutImage.imageLink }>
                            <div className={ `callout-img callout-${calloutImage.id}` }>
                                <img src={calloutImage.image.url.includes(cdnUrl) ? calloutImage.image.url : cdnUrl + calloutImage.image.url} alt={ calloutImage?.alternativeText } />
                                <div className="pulsating-circle" />
                                <span className="caption">{ calloutImage.imageCaption }</span>
                            </div>
                        </Link>
                    ))}
                </div>
                <div class="updated-hero-img-wrapper">
                  <img src={backgroundImage.url.includes(cdnUrl) ? backgroundImage.url : cdnUrl + backgroundImage.url} className="updated-hero-img" alt={ backgroundImage?.alternativeText } />
                </div>
            </div>
            }
          </div>
        </div>
      </div>
  )
}

export default HeroUpdated
